module.exports = __webpack_public_path__ + "img/symbol_7.b5c38cc4.png";